import { TriangleAlert } from 'lucide-react'
import classNames from 'classnames'

import Label from '@/elements/Label'
import Flex from '@/elements/Flex'

import './FormTextArea.scss'

interface FormTextAreaProps {
  className?: string
  value?: string
  name: string
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void
  onBlur?: (e: React.FocusEvent<HTMLTextAreaElement>) => void
  label?: string
  placeholder?: string
  rows?: number
  disabled?: boolean
  charCounterLimit?: number
  dirty?: boolean
  error?: string
  style?: React.CSSProperties
}

function FormTextArea({
  className,
  value,
  name,
  onChange,
  onBlur,
  label,
  placeholder,
  rows = 2,
  disabled = false,
  charCounterLimit,
  dirty = false,
  error,
  style
}: FormTextAreaProps) {

  const charCountExceeded = charCounterLimit ? (value ? value.length > charCounterLimit : false) : false

  return (
    <div className={classNames('form-field', className, { dirty })} style={style}>
      <Label htmlFor={name} hidden={!label}>{label}</Label>
      <textarea
        id={name}
        name={name}
        placeholder={placeholder}
        disabled={disabled}
        rows={rows}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
      />
      <Flex inline justify='flex-start' align='center' gap={1}>
        {charCounterLimit && (
          <span className={charCountExceeded ? 'field-error' : 'field-counter'}>
            {value?.length}/{charCounterLimit}
          </span>
        )}
        {error && (
          <span className='field-error'>
            <TriangleAlert size={12} />
            {error}
          </span>
        )}
      </Flex>
    </div>
  )
}

export default FormTextArea
